// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"venueDetails_infoRow__SC_sd","withIcon":"venueDetails_withIcon__VwQkR","text":"venueDetails_text__hL0ex","tagCount":"venueDetails_tagCount__3mVvR"};